import { render, staticRenderFns } from "./MktAutorizeDetail.vue?vue&type=template&id=70effffe&"
import script from "./MktAutorizeDetail.vue?vue&type=script&lang=js&"
export * from "./MktAutorizeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports